var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletLimsAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 182,
    viewBox: "0 0 152 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.085 145.478C111.015 137.27 102.436 106.129 80.9241 75.9228C59.4122 45.7161 33.1134 27.8823 22.1839 36.09C11.2545 44.2976 19.8334 75.4386 41.3453 105.645C62.8572 135.852 89.156 153.686 100.085 145.478Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7878 115.789C100.018 111.76 128.208 97.2884 126.75 83.465C125.293 69.6416 94.7402 61.7011 58.5096 65.7294C22.2789 69.7578 -5.91022 84.2295 -4.45268 98.053C-2.99513 111.876 27.5572 119.817 63.7878 115.789Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5003 152.765C46.8872 158.381 68.8607 135.181 83.5795 100.946C98.2982 66.7107 100.189 34.4051 87.8016 28.7894C75.4146 23.1736 53.4411 46.3741 38.7224 80.6092C24.0036 114.844 22.1133 147.15 34.5003 152.765Z",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5315 99.1945C62.0588 101.247 67.3492 99.1422 69.3479 94.4931C71.3467 89.8441 69.2969 84.4115 64.7696 82.359C60.2423 80.3064 54.9519 82.4114 52.9532 87.0604C50.9544 91.7094 53.0042 97.142 57.5315 99.1945Z",
    fill: "#80FFAF",
    stroke: "#263238",
    strokeWidth: 1.2835,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletLimsAtom1);
export default __webpack_public_path__ + "static/media/tablet-lims-atom-1.dfccb007d15d57179ab090e2ca194cd8.svg";
export { ForwardRef as ReactComponent };